module.exports = __webpack_public_path__ + "img/journey.e807f1df.gif";